import React, { useState } from 'react';
import { Field } from 'redux-form';

import Lightbox from 'react-image-lightbox';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import * as formatter from 'helpers/Formatter';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import MenuItem from '@material-ui/core/MenuItem';
import { maxNumberLength } from 'helpers/Formatter';
import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';
import { padDetailsTypes } from 'helpers/constants';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import { RenderGhostError } from 'components/shared/RenderError';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { localizeChequeImage } from 'helpers/Localization';
import warningIcon from 'assets/warning-yellow.png';
import { featureEnabled } from 'helpers/ToggleBot';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';
import { Fragment } from 'react';

const AutoPayDetails = ({ externalAutopayMinDay, province, padDetailType }) => {
  const [exampleIsOpen, setExampleIsOpen] = useState(false);

  // If today is between external autopay minimum day and end of month, skip this next month for being selectable
  // i.e. if min day is 23rd and it's April 25th, next selectable day is June 1st
  // if it's April 17th, next selectable day is May 1st
  const monthsToSkip = new Date().getDate() > externalAutopayMinDay ? 2 : 1;
  let minDate = new Date();
  minDate.setDate(1);
  minDate.setMonth(minDate.getMonth() + monthsToSkip);

  const enableDays = date => {
    const today = new Date();
    // nextMonthDate: setMonth mutates the variable so creating a new one to use
    // when checking for the second month
    let nextMonthDate = new Date();
    if (monthsToSkip === 2) {
      // when months to skip is 2, check disable the next month as well.
      // if today.getMonth() + 1 == 12, it will set date to januaray of next year
      nextMonthDate.setMonth(today.getMonth() + 1);
    }

    if (
      date.getMonth() === today.getMonth() ||
      (monthsToSkip === 2 && date.getMonth() === nextMonthDate.getMonth())
    ) {
      return false;
    } else {
      const provinceIsQuebecCapreit = hostIsCapreit() && province === 'Quebec';
      return date.getDate() === 1 || (provinceIsQuebecCapreit && date.getDate() === 5);
    }
  };

  let customDays = [
    {
      label: 1,
      value: 1,
    },
  ];
  if (province === 'Quebec') {
    customDays.push({
      label: 5,
      value: 5,
    });
  }

  const getCustomMonthRanges = (start, end, children) => {
    let valArray = [];
    for (let i = start; i <= end; i++) {
      valArray.push({
        label: i,
        value: i,
        children: children,
      });
    }
    return valArray;
  };

  const getFullCustomDates = (start, end, currentYearMonths, futureYearMonths) => {
    let valArray = [];
    for (let i = start; i <= end; i++) {
      if (i === start) {
        valArray.push({
          label: i,
          value: i,
          children: currentYearMonths,
        });
      } else {
        valArray.push({
          label: i,
          value: i,
          children: futureYearMonths,
        });
      }
    }
    return valArray;
  };

  const customMonthsCurrentYear = getCustomMonthRanges(minDate.getMonth() + 1, 12, customDays);

  const customMonthsFutureYears = getCustomMonthRanges(1, 12, customDays);

  const customDates = getFullCustomDates(
    minDate.getFullYear(),
    minDate.getFullYear() + 5,
    customMonthsCurrentYear,
    customMonthsFutureYears
  );

  const isACH = padDetailType === padDetailsTypes.ACH;

  let chequeImage = localizeChequeImage(getCurrentLocale(), padDetailType);

  return (
    <div>
      <div className="row" style={{ margin: '5px 0 15px 0' }}>
        <RenderIfToggleOn toggle="external_autopay">
          <div className="col-xs-12">
            <label
              style={{
                textAlign: 'initial',
                fontSize: '16px',
              }}
            >
              {featureEnabled('external_autopay')
                ? getTranslatedString('preauthorizedpayment.startDate')
                : getTranslatedString('autopay.startDate')}
            </label>
            <Field // TODO Be able to change border color on focus for date picker and text fields
              name="autopay_start_date"
              component={DatePickerAccessible}
              type="date"
              minDate={minDate}
              selected={minDate}
              initialValue={minDate}
              fullWidth
              filterDate={enableDays}
              validate={[validator.required]}
              formatDate={formatter.reformatDate}
              specificDatePickerMobile={true}
              customDates={customDates}
            />
          </div>
        </RenderIfToggleOn>
        {isACH ? <ACHDetails /> : <EFTDetails />}
      </div>
      <div className="row" style={{ textAlign: 'center' }}>
        <button type="button" className="link-button" onClick={() => setExampleIsOpen(true)}>
          {getTranslatedString('whereFindDetails')}
        </button>
        {exampleIsOpen && (
          <Lightbox onCloseRequest={() => setExampleIsOpen(false)} mainSrc={chequeImage} />
        )}
      </div>
      {featureEnabled('external_autopay') && (
        <div className="row" style={{ margin: '20px' }}>
          <h5
            style={{
              textAlign: 'center',
              fontSize: '18px',
              marginBottom: '15px',
            }}
          >
            {getTranslatedString('uploadVoidCheque')}
          </h5>
          <Field name={'voidChequeImage'} component={RenderGhostError} />
          <div className="row" style={{ textAlign: 'center' }}>
            <div className="col-md-12">
              <Field
                name="voidChequeImage"
                component={ReduxDropzone}
                style={{
                  border: `1px dashed ${colors.LIGHT_GRAY}`,
                  width: '40%',
                  margin: 'auto',
                  textAlign: 'center',
                }}
                fileValidation=".jpeg, .png, .jpg"
                size={100}
                labelText={getTranslatedString('clickToAddFile')}
                validate={[validator.required]}
                maxFileSize={10000000}
                fileSizeErrorMessage={getTranslatedString('autopay.fileSizeError', {
                  maxFileSize: 10,
                })}
                fileSizeErrorIcon={warningIcon}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoPayDetails;

const EFTDetails = () => (
  <Fragment>
    <div className="col-xs-12 fs-exclude" style={{ marginTop: '15px' }}>
      <label
        style={{
          textAlign: 'initial',
          fontSize: '16px',
        }}
      >
        {getTranslatedString('autopay.transitBranchNumber')}
      </label>
      <Field // TODO Be able to change border color on focus for date picker and text fields
        name="transit_number"
        component={TextField}
        normalize={maxNumberLength(5)}
        validate={[validator.transitNumber]}
        variant="outlined"
      />
    </div>
    <div className="col-xs-12 fs-exclude" style={{ marginTop: '15px' }}>
      <label
        style={{
          textAlign: 'initial',
          fontSize: '16px',
        }}
      >
        {getTranslatedString('autopay.institutionNumber')}
      </label>
      <Field // TODO Be able to change border color on focus for date picker and text fields
        name="institution_number"
        component={TextField}
        normalize={maxNumberLength(3)}
        validate={[validator.institutionNumber]}
        variant="outlined"
      />
    </div>
    <div className="col-xs-12 fs-exclude" style={{ marginTop: '15px' }}>
      <label
        style={{
          textAlign: 'initial',
          fontSize: '16px',
        }}
      >
        {getTranslatedString('autopay.accountNumber')}
      </label>
      <Field // TODO Be able to change border color on focus for date picker and text fields
        name="account_number"
        component={TextField}
        normalize={maxNumberLength(12)}
        validate={[validator.accountNumber]}
        variant="outlined"
      />
    </div>
  </Fragment>
);

const ACHDetails = () => (
  <Fragment>
    <div className="col-xs-12 fs-exclude" style={{ marginTop: '15px' }}>
      <label
        style={{
          textAlign: 'initial',
          fontSize: '16px',
        }}
      >
        {getTranslatedString('autopay.routingNumber')}
      </label>
      <Field // TODO Be able to change border color on focus for date picker and text fields
        name="routing_number"
        component={TextField}
        normalize={maxNumberLength(9)}
        validate={[validator.routingNumber]}
        variant="outlined"
      />
    </div>
    <div className="col-xs-12 fs-exclude" style={{ marginTop: '15px' }}>
      <label
        style={{
          textAlign: 'initial',
          fontSize: '16px',
        }}
      >
        {getTranslatedString('autopay.accountNumber')}
      </label>
      <Field // TODO Be able to change border color on focus for date picker and text fields
        name="account_number"
        component={TextField}
        normalize={maxNumberLength(17)}
        validate={[validator.accountNumberACH]}
        variant="outlined"
      />
    </div>
    <div className="col-xs-12 fs-exclude" style={{ marginTop: '15px' }}>
      <label
        style={{
          textAlign: 'initial',
          fontSize: '16px',
        }}
      >
        {getTranslatedString('autopay.accountType')}
      </label>
      <Field
        name="ach_account_type"
        component={OutlinedSelect}
        validate={[validator.required]}
        fullWidth
      >
        <MenuItem value="checking">{getTranslatedString('autopay.checking')}</MenuItem>
        <MenuItem value="savings">{getTranslatedString('autopay.savings')}</MenuItem>
        <MenuItem value="loan">{getTranslatedString('autopay.loan')}</MenuItem>
      </Field>
    </div>
  </Fragment>
);
